{
  "title": "如何建立競賽輪次並設定時程",
  "description": "建立初賽／決賽等輪次，並設定每個輪次的報名、投稿、評分、結果公布時程。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "完成後，該場競賽有一或多個輪次，每個輪次都有完整的時程設定，系統會依這些時間自動控制報名、投稿、評分各階段何時開放。",
  "roleNote": "主辦方管理員",
  "prerequisites": ["已透過申請流程建立競賽並具備管理權限"],
  "pathLabel": "主辦方主控台 → 競賽設定 → 輪次",
  "steps": [
    {
      "title": "1. 建立輪次",
      "description": "為競賽新增一個輪次，指定輪次類型（初賽或決賽）與名稱；一場競賽可以只有一個輪次，也可以是初賽＋決賽的兩輪次賽制。"
    },
    {
      "title": "2. 設定完整時程鏈",
      "description": "依序設定「報名開始／結束」「投稿開始／結束」「評分開始／結束」「結果公布」共 5 段時間；系統會檢查這 5 段時間的先後順序合理（例如投稿結束不能早於投稿開始、評分開始不能早於投稿結束），任一環節都可以留空不設限制。報名與投稿的時間可以重疊；重疊期間競賽狀態會顯示為「報名中」，已完成報名與團隊設定的參賽者仍可開始或繼續準備作品。"
    },
    {
      "title": "3. 綁定投稿表與評分規準",
      "description": "為這個輪次指定要使用的投稿表版本與預設評分規準，評審與參賽者會依此輪次綁定的版本填寫與評分。"
    },
    {
      "title": "4. 視需要調整輪次狀態",
      "description": "輪次狀態有「草稿／開放／評分中／已結束」，可視實際進度手動調整，讓參賽者與評審看到目前所處的階段。"
    }
  ],
  "afterward": [
    "該輪次的時程會自動控制參賽者何時能報名、投稿，以及評審何時能開始評分",
    "多輪次競賽的每個輪次時程彼此獨立設定，互不影響；賽程日期以輪次為準，總覽頁顯示的競賽層級日期會由系統依各輪次自動同步為最早開始與最晚結束，不需要也不應另外修改"
  ],
  "nextSteps": "設定好時程後，請見「如何建立與發布表單」設定該輪次要使用的報名表與投稿表。",
  "faq": [
    {
      "q": "投稿截止時間可以晚於評分開始時間嗎？",
      "a": "不行，系統的時程鏈規則要求投稿結束時間不能晚於評分開始時間（若兩者都有設定），送出設定時會被拒絕並標示衝突的欄位。"
    },
    {
      "q": "一定要設定所有 5 段時間嗎？",
      "a": "不用，每一段都可以留空代表「不限制」；但留空的時段前後關係檢查會被略過，需自行留意實際運作是否符合預期。"
    },
    {
      "q": "什麼情況下需要建立兩個輪次？",
      "a": "當競賽採初賽晉級決賽的賽制時，需要分別建立「初賽」與「決賽」兩個輪次，並透過「晉級」功能決定哪些隊伍從初賽進入決賽；單輪次競賽只需要建立一個輪次即可。"
    },
    {
      "q": "延長某個輪次的報名截止時間，需要同時修改總覽頁的日期嗎？",
      "a": "不需要。只要在「賽程輪次」頁修改該輪次的報名截止時間，系統會自動同步競賽層級的日期，公開頁、參賽者頁與伺服器端的截止判斷都會一致更新。"
    }
  ]
}
